import { editJobWorker, addJobWorker } from '../api';
import { dispatchErrorAction } from './index';
import { EDIT_JOB_WORKER_SUCCESS, ADD_JOB_WORKER_SUCCESS } from './actionTypes';

export function editJobWorkerAction (workerId, jobWorkerData) {
  return dispatch => editJobWorker(workerId, jobWorkerData)
    .then(() => {
      dispatch({ type: EDIT_JOB_WORKER_SUCCESS });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function addJobWorkerAction (workerData) {
  return dispatch => addJobWorker(workerData)
    .then(() => {
      dispatch({ type: ADD_JOB_WORKER_SUCCESS });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/jobWorkers.js